import CodeError from './CodeError';

class InvalidCashStatusError extends CodeError {
  constructor() {
    const code = 'invalidPaymentStatus';
    const message = 'Invalid serial number';
    super(code, message);
    if ('function' === typeof Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error(message)).stack;
    }
  }
}

export default InvalidCashStatusError;
